module.exports = __webpack_public_path__ + "static/media/time_img.89b45ffd.jpg";